import { render, staticRenderFns } from "./mobilePlatformView.vue?vue&type=template&id=8fffad02&scoped=true"
import script from "./mobilePlatformView.vue?vue&type=script&lang=js"
export * from "./mobilePlatformView.vue?vue&type=script&lang=js"
import style0 from "./mobilePlatformView.vue?vue&type=style&index=0&id=8fffad02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fffad02",
  null
  
)

export default component.exports